import { gql } from "graphql-request";

const fundraisingModule = window.cornerstoneFundraisingModuleId;
const paymentModule = window.cornerstonePaymentModuleId;
const stripePaymentOption = '';

const avtalegiroMutation = gql`
mutation PrepareGift($amount: Float!, $causeId: Int!, $paymentOptionId: Int!, $recurrence: RecurrenceIntervalEnum!, $email: String, $first: String, $last: String, $middle: String, $phone: String, $ssn: String, $successPageId: Int!, $cancelPageId: Int!) {
    room {
        fundraising(id: ${fundraisingModule}) {
            giftPrepare(
                data: {
                    amount: $amount,
                    causeId: $causeId,
                    paymentOptionId: $paymentOptionId,
                    recurrence: {interval: $recurrence, day: 15},
                    donor: {
                        email: $email,
                        type: PERSON,
                        personName: {
                            first: $first,
                            last: $last,
                            middle: $middle
                        },
                        phone: {
                            countryCode: "",
                            localNumber: $phone
                        },
                        ssn: $ssn
                    },
                    requestPayerInfo: false,
                    successPageId: $successPageId,
                    cancelPageId: $cancelPageId,
                    sourceName: "Nettsiden",
                    sourceReference: "API"
                }
            ) {
                redirectUrl
                gift {
                    id
                    date
                    paymentOption {
                        name
                        id
                    }
                }
                userErrors {
                    message
                }
            }
        }
    }
}
`;

const stripeMutation = gql`
mutation PrepareGift($amount: Float!, $causeId: Int!, $paymentOptionId: Int!, $recurrence: RecurrenceIntervalEnum!, $email: String, $first: String, $last: String, $middle: String, $phone: String, $ssn: String, $successPageId: Int!, $cancelPageId: Int!) {
    room {
        fundraising(id: ${fundraisingModule}) {
            giftPrepare(
                data: {
                    amount: $amount,
                    causeId: $causeId,
                    paymentOptionId: $paymentOptionId,
                    recurrence: {interval: $recurrence, day: 15},
                    donor: {
                        email: $email,
                        type: PERSON,
                        personName: {
                            first: $first,
                            last: $last,
                            middle: $middle
                        },
                        phone: {
                            countryCode: "",
                            localNumber: $phone
                        },
                        ssn: $ssn
                    },
                    requestPayerInfo: false,
                    successPageId: $successPageId,
                    cancelPageId: $cancelPageId,
                    sourceName: "Nettsiden",
                    sourceReference: "API"
                }
            ) {
                gift {
                    id
                    date
                    paymentOption {
                        name
                        id
                    }
                }
                invoiceEncodedId
                userErrors {
                    message
                }
            }
        }
    }
}
`;

const vippsMutation = gql`
mutation PrepareGift($amount: Float!, $causeId: Int!, $paymentOptionId: Int!, $recurrence: RecurrenceIntervalEnum!, $successPageId: Int!, $cancelPageId: Int!) {
    room {
        fundraising(id: ${fundraisingModule}) {
            giftPrepare(
                data: {
                    amount: $amount,
                    causeId: $causeId,
                    paymentOptionId: $paymentOptionId,
                    recurrence: {interval: $recurrence, day: 15},
                    requestPayerInfo: true,
                    successPageId: $successPageId,
                    cancelPageId: $cancelPageId,
                    sourceName: "Nettsiden",
                    sourceReference: "API"
                }
            ) {
                gift {
                    id
                    date
                    paymentOption {
                        name
                        id
                    }
                }
                invoiceEncodedId
                paymentProfileEncodedId
                userErrors {
                    message
                }
            }
        }
    }
}
`;

const vippsPaymentInitiateMutation = gql`
mutation PaymentInitiate($invoiceEncodedId: String!) {
    room {
      payment(id: ${paymentModule}) {
        vippsPaymentInitiate(
            data: {invoiceEncodedId: $invoiceEncodedId, paymentOptionId: 10398, requestPayerInfo: true, phoneNumber: ""}
        ) {
            redirectUrl
        }
      }
    }
  }
`;
const vippsPaymentProfileInitiateMutation = gql`
mutation PaymentProfileInitiate($paymentProfileEncodedId: String!) {
    room {
      payment(id: ${paymentModule}) {
        vippsPaymentProfileInitiate(
            data: {paymentProfileEncodedId: $paymentProfileEncodedId, requestPayerInfo: true}
        ) {
            redirectUrl
        }
      }
    }
  }
`;

const stripePublicKeyQuery = gql`
query StripePublicKey($encodedId: String!) {
    room {
      paymentInvoiceByEncodedId(encodedId: $encodedId) {
        module {
          paymentOptions(filters: {id: ${stripePaymentOption}}) {
            items {
              ... on PaymentOptionStripe {
                id
                name
                publicKey
              }
            }
          }
        }
      }
    }
  }
`;

const stripePaymentIntentCreateMutation = gql`
mutation Intent($invoiceEncodedId: String!, $stripePaymentMethodId: String!) {
    room {
      payment(id: ${paymentModule}) {
        stripePaymentIntentCreate(
          data: {invoiceEncodedId: $invoiceEncodedId, stripePaymentMethodId: $stripePaymentMethodId}
        ) {
          paymentIntent {
            clientSecret
            status
          }
          invoice {
            successUrl
          }
          userErrors {
            field
            message
          }
        }
      }
    }
  }`;
const stripePaymentIntentConfirmMutation = gql`
mutation Intent($invoiceEncodedId: String!, $paymentIntentId: String!) {
    room {
      payment(id: ${paymentModule}) {
        stripePaymentIntentConfirm(
          data: {invoiceEncodedId: $invoiceEncodedId, paymentIntentId: $paymentIntentId}
        ) {
          paymentIntent {
            clientSecret
            status
          }
          invoice {
            successUrl
          }
          userErrors {
            field
            message
          }
        }
      }
    }
  }`;

export {
  avtalegiroMutation,
  vippsMutation,
  stripeMutation,
  vippsPaymentInitiateMutation,
  vippsPaymentProfileInitiateMutation,
  stripePublicKeyQuery,
  stripePaymentIntentCreateMutation,
  stripePaymentIntentConfirmMutation,
};
